import { AccordionCard } from "../../../../accordion/Accordion";
import FirmaRelationer from "./FirmaRelationer";
import FirmaPersonRelationer from "./FirmaPersonRelationer";
import FirmaKorrespondance from "./FirmaKorrespondance";
import FirmaHistorikStamdata from "./FirmaHistorikStamdata";
import FirmaAbonnementer from "./FirmaAbonnementer";
import FirmaAltFaktureringsAdresser from "./FirmaAltFaktureringsAdresser";
import StamoplysningerTop from "./stamoplysninger/StamoplysningerTop";
import { FirmaDto } from "../../../../../interfaces/schema";
import { useState } from "react";
import FirmaHistorikStamdata2 from "./FirmaHistorikStamdata2";

export default function Stamoplysninger({
  firma,
  invalidateData,
}: {
  firma: FirmaDto;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const [editMode, setEditMode] = useState(false);

  return (
    <div className="container">
      <StamoplysningerTop
        editMode={editMode}
        firma={firma}
        setEditMode={setEditMode}
        invalidateData={invalidateData}
      />
      <AccordionCard
        title="Personrelationer"
        value="personrelationer"
        isEmpty={!firma?.personFirma?.length}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaPersonRelationer firmaId={firma.id} />
      </AccordionCard>

      <AccordionCard
        title="Firmarelationer"
        value="firmarelationer"
        isEmpty={
          !firma?.firmaejerskabEjendeFirmaNavigation?.length &&
          !firma?.firmaejerskabEjetFirma?.length
        }
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaRelationer firma={firma} invalidateData={invalidateData} />
      </AccordionCard>

      <AccordionCard
        title="Historik stamdata fra AMK"
        value="historik-stamdata"
        isEmpty={!firma?.firmahistorikNavigation?.length}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaHistorikStamdata id={firma.id} />
      </AccordionCard>

      <AccordionCard
        title="Historik stamdata Aika"
        value="historik-stamdata-2"
        isEmpty={!firma?.firmahistorik2Navigation?.length}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaHistorikStamdata2 id={firma.id} />
      </AccordionCard>

      <AccordionCard
        title="Korrespondance"
        value="korrespondance"
        isEmpty={!firma?.firmaKorrespondance?.length}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaKorrespondance firma={firma} invalidateData={invalidateData} />
      </AccordionCard>

      <AccordionCard
        title="Abonnementer"
        value="abonnementer"
        isEmpty={!firma?.firmaAbonnement?.length}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
      >
        <FirmaAbonnementer firma={firma} invalidateData={invalidateData} />
      </AccordionCard>

      <FirmaAltFaktureringsAdresser firmaId={firma.id} />
    </div>
  );
}
